import { useEffect, useRef, useState } from "react";

import { useParams } from "react-router-dom";

import { useSupplierShipments } from "hooks";
import { getPageCount } from "utils";

import { SupplierShipment } from "../SupplierShipment";
import { SupplierShipmentOverviewExpanded } from "../SupplierShipmentOverviewExpanded";

const QUICK_SUPPLIER_SHIPMENT_BROWSER_PAGE_SIZE = 5;

export function SupplierShipmentContainer() {
  const params = useParams();
  const shipmentId = params.id;
  const [page, setPage] = useState<number>(1);
  const shipmentRef = useRef<SupplierShipment | undefined>(undefined);

  const {
    supplierShipments,
    isLoading: shipmentsAreLoading,
    count,
    refreshSupplierShipments,
  } = useSupplierShipments({
    page,
    pageSize: QUICK_SUPPLIER_SHIPMENT_BROWSER_PAGE_SIZE,
  });

  const pages = getPageCount(count, QUICK_SUPPLIER_SHIPMENT_BROWSER_PAGE_SIZE);
  const selectedShipment = supplierShipments.find(
    (shipment) => shipment.info.id === parseInt(shipmentId ?? "0", 10),
  );

  const handlePageChange = (
    _e: React.ChangeEvent<unknown>,
    value: number,
  ): void => {
    setPage(value);
  };

  useEffect(() => {
    if (
      selectedShipment &&
      shipmentRef.current?.info?.id !== selectedShipment.info.id
    ) {
      shipmentRef.current = selectedShipment;
      refreshSupplierShipments();
    }
  }, [selectedShipment, refreshSupplierShipments]);

  if (!shipmentId) {
    return null;
  }

  return (
    <SupplierShipment
      supplierShipmentOverview={
        <SupplierShipmentOverviewExpanded shipmentId={Number(shipmentId)} />
      }
      supplierShipments={supplierShipments}
      shipmentSelectionIsDisabled={shipmentsAreLoading}
      page={page}
      pages={pages}
      handlePageSelected={handlePageChange}
      shipmentCount={count}
    />
  );
}
